import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { DestinoControlService } from './destinocontrol.service';
import { HttpParams } from '@angular/common/http';
import { DestinoControlItemResultsViewModel, DestinoControlViewModel, FilterSearchingDestinoControlViewModel } from './destinocontrol.types';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { Table } from 'primeng/table';
import { Tc, EnumSiNoTodos } from '../../../core/_infrastructure/types/common';
import { SelectItem } from 'primeng/api';

@Component({
    selector: 'app-destinocontrol-list',
    templateUrl: './destinocontrol-list.component.html',
})
export class DestinoControlListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    listSiNoTodos: SelectItem[];
    listPais: Tc[];

    resultDestinoControl: DestinoControlItemResultsViewModel;
    cols: any[];

    visibilitySpinner: boolean = false;

    public isCollapsed = false;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private destinoControlService: DestinoControlService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultDestinoControl = new DestinoControlItemResultsViewModel();
    }

    ngOnInit() {
        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Descripcion', header: 'Descripción' },
            { field: 'IdPaisDescripcion', header: 'País' },
            { field: 'IdentificadorTraces', header: 'Identificador Traces' },
            { field: 'Direccion', header: 'Dirección' },
            { field: 'Localidad', header: 'Localidad' },
            { field: 'CodigoZip', header: 'Código Zip' },
            { field: 'Activo', header: 'Activo' },
        ];

        this.form = this.fb.group({
            Descripcion: '',
            IdPais: null,
            IdentificadorTraces: '',
            Direccion: '',
            Localidad: '',
            CodigoZip: '',
            Activo: EnumSiNoTodos.TODOS,
        });

        this.globalService.getPaisesUe().subscribe(res => {
            this.listPais = res;
        });

        //p-selectButton
        this.listSiNoTodos = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
            { label: 'TODOS', value: EnumSiNoTodos.TODOS },
        ];

        this.loadBack();
    }

    loadBack() {
        if (
            this.destinoControlService.currentFilterDestinoControl.Descripcion != '' ||
            this.destinoControlService.currentFilterDestinoControl.IdPais != null ||
            this.destinoControlService.currentFilterDestinoControl.IdentificadorTraces != '' ||
            this.destinoControlService.currentFilterDestinoControl.Direccion != '' ||
            this.destinoControlService.currentFilterDestinoControl.Localidad != '' ||
            this.destinoControlService.currentFilterDestinoControl.CodigoZip != '' ||
            this.destinoControlService.currentFilterDestinoControl.Activo != EnumSiNoTodos.TODOS
        ) {
            this.form.patchValue({
                Descripcion: this.destinoControlService.currentFilterDestinoControl.Descripcion,
                IdPais: this.destinoControlService.currentFilterDestinoControl.IdPais,
                IdentificadorTraces: this.destinoControlService.currentFilterDestinoControl.IdentificadorTraces,
                Direccion: this.destinoControlService.currentFilterDestinoControl.Direccion,
                Localidad: this.destinoControlService.currentFilterDestinoControl.Localidad,
                CodigoZip: this.destinoControlService.currentFilterDestinoControl.CodigoZip,
                Activo: this.destinoControlService.currentFilterDestinoControl.Activo,
            });

            this.onSearchButton();
        }
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.destinoControlService.currentFilterDestinoControl.Descripcion = this.form.value.Descripcion;
        this.destinoControlService.currentFilterDestinoControl.IdPais = this.form.value.IdPais;
        this.destinoControlService.currentFilterDestinoControl.IdentificadorTraces = this.form.value.IdentificadorTraces;
        this.destinoControlService.currentFilterDestinoControl.Direccion = this.form.value.Direccion;
        this.destinoControlService.currentFilterDestinoControl.Localidad = this.form.value.Localidad;
        this.destinoControlService.currentFilterDestinoControl.CodigoZip = this.form.value.CodigoZip;
        this.destinoControlService.currentFilterDestinoControl.Activo = this.form.value.Activo;

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    Search(pageNumber: number, asc: number = 0, orderBy: string = '') {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('Descripcion', this.form.value.Descripcion);
        params = params.append('IdPais', this.form.value.IdPais);
        params = params.append('IdentificadorTraces', this.form.value.IdentificadorTraces);
        params = params.append('Direccion', this.form.value.Direccion);
        params = params.append('Localidad', this.form.value.Localidad);
        params = params.append('CodigoZip', this.form.value.CodigoZip);
        params = params.append('Activo', this.form.value.Activo);

        this.loading = true;
        this.destinoControlService.getDestinoControlPagedByFilter(params).subscribe(result => {
            this.resultDestinoControl = result;
            this.loading = false;
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;

        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton() {
        this.form.setValue({
            Descripcion: '',
            IdPais: null,
            IdentificadorTraces: '',
            Direccion: '',
            Localidad: '',
            CodigoZip: '',
            Activo: EnumSiNoTodos.TODOS,
        });

        this.searchingButton = false;
        this.isCollapsed = false;

        this.resultDestinoControl = new DestinoControlItemResultsViewModel();
    }

    onAdd() {
        this.router.navigate(['/mantenimiento/general/destinoscontrol/create']);
    }

    onEdit(item: DestinoControlViewModel) {
        this.router.navigate(['/mantenimiento/general/destinoscontrol/edit', item.Id]);
    }

    CreateModel() {
        let model: FilterSearchingDestinoControlViewModel = new FilterSearchingDestinoControlViewModel();

        Object.assign(model, this.form.value);

        return model;
    }

    onExportExcel() {
        this.visibilitySpinner = true;

        this.destinoControlService.export(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinner = false;
        });
    }
}
